export default __webpack_public_path__ + "static/media/sdr-flow.ff591382.png";